import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';

import { RequestWorkspaceChildEntityUpdateShareStatus } from '@shared/dto/+workspace/workspace_entity/_requests/request_workspace_child_entity_update_share_status';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__collections } from '../../collection/STATE__collections';

export const remote_workspace_child_entity_share_status_update = createAsyncThunkSafe<void, RequestWorkspaceChildEntityUpdateShareStatus[]>(
  ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_UPDATE_SHARE_STATUS,
  async (requests, thunkApi): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORKSPACE_CHILD_ENTITY_UPDATE_SHARE_STATUS, requests);
  },
);

export function init_remote_workspace_child_entity_share_status_update(builder: ActionReducerMapBuilder<STATE__collections>) {
  builder
    .addCase(remote_workspace_child_entity_share_status_update.pending, (state, action) => {})
    .addCase(remote_workspace_child_entity_share_status_update.rejected, (state, action) => {})
    .addCase(remote_workspace_child_entity_share_status_update.fulfilled, (state, action: PayloadAction) => {});
}
